import React from "react";
import useClientConfig from "../../../../../config/careers/clientConfig";

const EquityBanner = () => {
    const {clientAssetsLink} = useClientConfig();

    return (
        <div className="banner-wrapper" style={{backgroundImage: `url("${clientAssetsLink+"/Careers - Hero Banner - BG image.jpg"}`}}>
            <div className="banner-content container mx-auto" >
                <div className="banner-text">
                    <h1>Careers</h1>
                    <p>{"Build your career with teams that scale businesses."}</p>
                </div>
            </div>
        </div>
    );
};

export default EquityBanner;